import React from "react";
import FNFTLayout from "./FNFTLayout";
import "./FNFTPersonal.scss";

const FNFTHome = () => {
  return (
    <FNFTLayout>
      <div className="home">
        <h1 className="home__title">Raise Funds with Fractional NFTs</h1>
        <p className="home__description">
          Leverage the power of blockchain and community ownership to fund your projects.
        </p>
        <div className="home__actions">
          <a href="/mint" className="home__button home__button--primary">Start Fractionalizing</a>
          <a href="/campaign" className="home__button home__button--secondary">Learn More</a>
        </div>
      </div>
    </FNFTLayout>
  );
};

export default FNFTHome;
